import { MobileTextFieldForm, TextFieldAttributes, TextFieldForm } from "./TextField";
import { InputFieldAttributes, InputFieldForm, MobileInputFieldForm } from "./InputField";
import { TextAreaFieldAttributes, TextAreaFieldForm, MobileTextAreaFieldForm } from "./TextAreaField";
import { MobileTimeFieldForm, TimeFieldAttributes, TimeFieldForm } from "./TimeField";
import { DateFieldAttributes, MobileDateFieldForm, DateFieldForm } from "./DateField";
import { YesNoNAFieldAttributes, YesNoNAFieldForm, MobileYesNoNAFieldForm } from "./YesNoNA";
import { SelectFieldAttributes, SelectFieldForm, MobileSelectFieldForm } from "./SelectField";
import { MultiSelectFieldAttributes, MultiSelectFieldForm, MobileMultiSelectFieldForm } from "./MultiSelectField";
import { ToggleFieldAttributes, ToggleFieldForm, MobileToggleFieldForm } from "./ToggleField.jsx";
// import { MaintenanceItemAttributes, MaintenanceItemFieldForm, MobileMaintenanceItemFieldForm } from "./MaintenanceItem.old";
import { AttachmentsAttributes, AttachmentsForm, MobileAttachmentsForm } from "./Attachments";
import _ from "lodash";
import { CheckboxFieldAttributes, CheckboxFieldForm } from "./CheckboxField";
import { ProjectVariationAttributes, ProjectVariationFieldForm } from "./ProjectVairationField";
import { MobileProjectFieldForm, ProjectAttributes, ProjectFieldForm } from "./ProjectField";
import { AlertFieldAttributes, AlertFieldForm, MobileAlertFieldForm } from "./AlertField";
import { EmployeeFieldAttributes, EmployeeFieldForm, MobileEmployeeFieldForm } from "./EmployeeField";
import { UserFieldAttributes, UserFieldForm } from "./UserField";
import { CompanyAttributes, CompanyFieldForm, MobileCompanyFieldForm } from "./CompanyField";
import { InlineAttachmentsFieldAttributes, InlineAttachmentsFieldForm, MobileInlineAttachmentsFieldForm } from "./InlineAttachments";

const column_types = [
  { label: "Text", value: "text", attributesComponent: TextFieldAttributes, formComponent: TextFieldForm, mobileFormComponent: MobileTextFieldForm },
  {
    label: "Input",
    value: "input",
    attributesComponent: InputFieldAttributes,
    formComponent: InputFieldForm,
    mobileFormComponent: MobileInputFieldForm,
  },
  {
    label: "Alert",
    value: "alert",
    attributesComponent: AlertFieldAttributes,
    formComponent: AlertFieldForm,
    mobileFormComponent: MobileAlertFieldForm,
  },
  {
    label: "Textarea",
    value: "textarea",
    attributesComponent: TextAreaFieldAttributes,
    formComponent: TextAreaFieldForm,
    mobileFormComponent: MobileTextAreaFieldForm,
  },
  {
    label: "Select",
    value: "select",
    attributesComponent: SelectFieldAttributes,
    formComponent: SelectFieldForm,
    mobileFormComponent: MobileSelectFieldForm,
  },
  {
    label: "Multi Select",
    value: "multiselect",
    attributesComponent: MultiSelectFieldAttributes,
    formComponent: MultiSelectFieldForm,
    mobileFormComponent: MobileMultiSelectFieldForm,
    formatter: (cell) => {
      if (_.isArray(cell) || _.isObject(cell)) {
        return _.map(cell, (option) => option?.label).join(", ");
      }
      return "";
    },
  },
  {
    label: "Toggle",
    value: "toggle",
    attributesComponent: ToggleFieldAttributes,
    formComponent: ToggleFieldForm,
    mobileFormComponent: MobileToggleFieldForm,
    formatter: (cell) => (cell == "1" ? "Yes" : "No"),
  },
  {
    label: "Checkbox",
    value: "checkbox",
    attributesComponent: CheckboxFieldAttributes,
    formComponent: CheckboxFieldForm,
    // mobileFormComponent: MobileToggleFieldForm,
    formatter: (cell) => (cell == "1" ? "Yes" : "No"),
  },
  // {
  //   label: "Checklist",
  //   value: "checklist",
  //   attributesComponent: ChecklistFieldAttributes,
  //   formComponent: ChecklistFieldForm,
  //   // mobileFormComponent: MobileToggleFieldForm,
  // },
  {
    label: "Date",
    value: "date",
    attributesComponent: DateFieldAttributes,
    formComponent: DateFieldForm,
    mobileFormComponent: MobileDateFieldForm,
    formatter: (cell) => (cell ? moment(cell).format("DD/MM/YYYY") : "Not Set"),
  },
  {
    label: "Yes/No/NA",
    value: "yesnona",
    attributesComponent: YesNoNAFieldAttributes,
    formComponent: YesNoNAFieldForm,
    mobileFormComponent: MobileYesNoNAFieldForm,
  },
  // Move Maintenance Item to custom form belongs to
  // {
  //   label: "Maintenance Item",
  //   value: "maintenance_item",
  //   attributesComponent: MaintenanceItemAttributes,
  //   formComponent: MaintenanceItemFieldForm,
  //   mobileFormComponent: MobileMaintenanceItemFieldForm,
  //   formatter: (cell, row) => row.v2_maintenance_item_display_name,
  // },
  { label: "Time", value: "time", attributesComponent: TimeFieldAttributes, mobileFormComponent: MobileTimeFieldForm, formComponent: TimeFieldForm },
  {
    label: "User",
    value: "user",
    attributesComponent: UserFieldAttributes,
    formComponent: UserFieldForm,
  },
  {
    label: "Employee",
    value: "employee",
    attributesComponent: EmployeeFieldAttributes,
    formComponent: EmployeeFieldForm,
    mobileFormComponent: MobileEmployeeFieldForm,
  },
  {
    label: "Company",
    value: "company",
    attributesComponent: CompanyAttributes,
    formComponent: CompanyFieldForm,
    mobileFormComponent: MobileCompanyFieldForm,
  },
  {
    label: "Project",
    value: "project",
    attributesComponent: ProjectAttributes,
    formComponent: ProjectFieldForm,
    mobileFormComponent: MobileProjectFieldForm,
  },
  {
    label: "Project Variation",
    value: "project_variation",
    attributesComponent: ProjectVariationAttributes,
    formComponent: ProjectVariationFieldForm,
  },

  {
    label: "Attachments",
    value: "attachments",
    attributesComponent: AttachmentsAttributes,
    formComponent: AttachmentsForm,
    mobileFormComponent: MobileAttachmentsForm,
  },
  {
    label: "Inline Attachments",
    value: "inline_attachments",
    attributesComponent: InlineAttachmentsFieldAttributes,
    formComponent: InlineAttachmentsFieldForm,
    mobileFormComponent: MobileInlineAttachmentsFieldForm,
  },
];

export default column_types;
